module.exports = __webpack_public_path__ + "static/media/manzate_pro_stick.0f8e24c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/sigatoka_negra/preventiva/manzate_pro_stick.png
// module id = 1173
// module chunks = 3